import React, { useMemo } from "react";
import { useTrans } from "system/translations/hooks";
import { FormConfigType } from "../../services/formBuilder/types";
import DotsMenu from "components/atoms/DotsMenu";
import { useDefaultFieldsConfig } from "services/formBuilder/hooks";
import { TableColumnType } from "services/table/types";

export const useTableColumns = (): TableColumnType[] => {
  const { _t } = useTrans();
  const columns = useMemo(
    (): TableColumnType[] => [
      {
        Header: _t("id"),
        accessor: "id",
        id: "id",
      },
      {
        Header: _t("ip"),
        accessor: "ip",
        id: "ip",
        isMobileTitle: true,
      },
      {
        Header: _t("comment"),
        accessor: "comment",
        id: "comment",
      },
      {
        maxWidth: 65,
        Header: "",
        id: "actionMenu",
        Cell: (props: any) => {
          return (
            <DotsMenu
              clickParams={{
                id: props?.row?.original?.id,
                allData: props?.row?.original,
              }}
              items={props?.actionMenuItems}
            />
          );
        },
      },
    ],
    []
  );

  return columns;
};

export const useCreateEditConfig = (): FormConfigType => {
  const fields = useDefaultFieldsConfig();
  const formConfig = useMemo((): FormConfigType => {
    return [fields.formFields.ip(), fields.formFields.comment()];
  }, []);
  return formConfig;
};
